module.exports = __webpack_public_path__ + "img/img_thumb_0604.2cb7ad6c.png";